import React from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'

import { Box, Link } from '@material-ui/core'

import PATHS from '~/router/paths'

export default function ModifyButton({ text }: { text: string }) {
  const location = useLocation()
  return (
    <Box>
      <Link component={RouterLink} to={`${PATHS.OFFER_SETUP}${location.search}`} underline="always">
        {text}
      </Link>
    </Box>
  )
}
